"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _eventBus = require("@/helpers/event-bus.js");

var _vuex = require("vuex");

var _LotDetail = _interopRequireDefault(require("./components/LotDetail"));

var _AffaireTotaux = _interopRequireDefault(require("./components/AffaireTotaux"));

var CONST = _interopRequireWildcard(require("@/helpers/constantes"));

require("@/mixins/workflow");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = {
  name: 'ProvisionsRisquesIndex',
  components: {
    LotDetail: _LotDetail.default,
    AffaireTotaux: _AffaireTotaux.default
  },
  data: function data() {
    return {
      CONST: CONST,
      // pour rafraichir l'affichage apres ajout/modification/suppression d'un lot
      refresh: 0,
      // pour filtrer les provisions jusqu'à une date
      // dateMax: null,
      // mode saisie des montants
      modeEdit: false,
      // --- libelle de la nature
      formData: {
        lib_nature: ''
      },
      options: null,
      //
      userCanDoAction: false
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['user']), {
    affaire: function affaire() {
      return this.$store.getters.affaire;
    },
    dateFormat: function dateFormat() {
      return this.user.date_format; // dd/MM/yyyy
    }
  }),
  beforeMount: function () {
    var _beforeMount = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this = this;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getWorkflow('gestion_mensuelle').then(function () {
                _this.userCanDoAction = _this.isUserCanDoAction(_this.affaire.affaire.etape, 'gestion_mensuelle') || false;
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeMount() {
      return _beforeMount.apply(this, arguments);
    }

    return beforeMount;
  }(),
  mounted: function mounted() {
    _eventBus.EventBus.$emit('REFRESH_CALCULS');
  },
  methods: {
    getLibsNature: function getLibsNature() {
      // on récupére les libellés des natures déjà existants pour alimenter le déroulant des natures de provisions
      var libs = this.$store.getters.affaire.provisionsRisques.map(function (x) {
        return x.lib_nature;
      }).filter(function (x) {
        return x;
      });

      var uniqLibs = _toConsumableArray(new Set(libs));

      this.options = uniqLibs.map(function (x) {
        return {
          value: x,
          label: x
        };
      });
    },
    canEdit: function canEdit(etape) {
      // edition possible uniquement si on est sur la période de gestion courante.
      return this.affaire.YYYYMM === this.affaire.currentGestMensYYYYMM;
    },

    /*
    handleChangeDate (date) {
      this.dateMax = date
      EventBus.$emit('REFRESH_CALCULS', { date_max: this.dateMax })
    },
    */
    handleNewProvisionRisque: function handleNewProvisionRisque() {
      this.modeEdit = true;
      this.formData.lib_nature = '';
      this.getLibsNature();

      _eventBus.EventBus.$emit('PROVISIONRISQUE_NEW');

      _eventBus.EventBus.$emit('MODE_EDIT', true);
    },
    handleCancelProvisionRisque: function handleCancelProvisionRisque() {
      this.modeEdit = false;

      _eventBus.EventBus.$emit('PROVISIONRISQUE_CANCEL');

      _eventBus.EventBus.$emit('MODE_EDIT', false);
    },
    handleSaveProvisionRisque: function handleSaveProvisionRisque() {
      var _this2 = this;

      if (this.formData.lib_nature.trim() === '') {
        this.$confirm('Aucun libellé saisi pour la nature de la provision. Souhaitez-vous enregistrer cette nouvelle provision ?', 'Confirmation', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }).then(function () {
          _this2.saveProvisionRisque();
        });
      } else {
        this.saveProvisionRisque();
      }
    },
    saveProvisionRisque: function saveProvisionRisque() {
      this.modeEdit = false;

      _eventBus.EventBus.$emit('PROVISIONRISQUE_SAVE', this.formData.lib_nature.trim());

      _eventBus.EventBus.$emit('MODE_EDIT', false);

      this.$store.dispatch('affaire/setHistorique', _objectSpread({}, this.affaire.affaire, {
        message: 'Nouvelle provision n° ' + Number(this.affaire.nbColProvisionRisque + 1) + ' : ' + this.formData.lib_nature.trim()
      }));
      this.getLibsNature();
      this.refresh++;
    }
  }
};
exports.default = _default;